import {
  maxWidthContainerWithoutGutters,
  minBreakpoints,
  theme,
} from '@noths/polaris-client-ribbons-base';
import { mediaQuery } from '@noths/polaris-client-styles';
import { css } from 'styled-components';

const { fonts, responsiveText, spacing } = theme;

export const partnerPageHeaderWrapper = css`
  ${mediaQuery(
    { min: minBreakpoints.M },
    css`
      background-color: var(--brand-purple-5);
    `,
  )}
`;

export const container = css`
  ${maxWidthContainerWithoutGutters};
`;

export const pressCommentsSection = css`
  overflow: hidden;

  h2 {
    margin-left: ${spacing.lg}px;
    font-family: ${fonts.PRIMARY_SEMIBOLD.family};
    font-weight: ${fonts.PRIMARY_SEMIBOLD.weight};
    ${responsiveText.HEADING.SM};
    text-align: center;
  }

  ul {
    display: flex;
    flex-wrap: nowrap;
    margin: 0;
    padding: 0;
    list-style: none;
    overflow-x: auto;
    scroll-snap-type: x mandatory;
    -webkit-overflow-scrolling: touch;
  }

  li {
    flex: 0 0 calc((100% - ${spacing.xl}px) / 3);
    padding: 0 0 ${spacing.lg}px ${spacing.xl}px;
    min-width: 280px;
    scroll-snap-align: start;
  }
`;
